module.exports = __webpack_public_path__ + "static/media/ionic-ios-add-circle-outline.763e31dd.svg";